import Vue from 'vue'

// initial state
const state = {
  isLogin: false,
  user: {}
}

// getters
const getters = {
  isLogin: state => state.isLogin
}

// actions
const actions = {
  getUser ({ commit }) {
    Vue.http.get('api/me').then(resp => {
      if (resp.data.errcode !== 0) {
        commit('setIsLogin', false)
      }
      commit('setIsLogin', true)
    })
  },
  setUser ({ commit }, user) {
    if (user) {
      commit('setIsLogin', true)
    } else {
      commit('setIsLogin', false)
    }
    commit('setUser', user)
  }
}

// mutations
const mutations = {
  setIsLogin (state, isLogin) {
    state.isLogin = isLogin
  },
  setUser (state, user) {
    state.user = user
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js